import './header.css'
 export const Header = () => {
    return (
        <>
            <div id="icon-section">
                <div className="row justify-content-end text-align-center">
                    <div className="icon circle-icon"><a rel="noreferrer" target="_blank" href="https://www.linkedin.com/in/leslee-echivarre"><img alt="linkedin" src="./img/LI.png" /></a></div>
                    <div className="icon circle-icon"><a rel="noreferrer" target="_blank" href="https://instagram.com/leslee.echivarre"><img alt="insta" src="./img/IG.png" /></a></div>
                    <div className="icon circle-icon"><a rel="noreferrer" target="_blank" href="https://youtube.com/channel/UCEQj1vGCM0NFy8czdY729oQ"><img alt="youtube" src="./img/YT.png" /></a></div>
                </div>
            </div>
            <div id="header">
                <div className='row justify-content-center pt-5 fade-top text-cent'>
                    <h1 style={{fontWeight: "bold"}} className="cooper purple">leslee echivarre</h1>
                </div>
            </div>
        </>
    )
 }